import React, { useState } from "react";
import { TableHeadersType } from "../../../../constant/tableHeadersConstants/tableHeadersType";
import {
  BomDataItemType
} from "../../../../redux/invoiceGeneration/invoiceGenrationTypes";
import { grayViewIcon, LockGreyIcon, tableEditIcon, TableMoreDetails } from "../../../../assets/images";
import UpdatedByAndUpdatedAt from "../../../commons/CommonUpdatedByAndUpdatedAt";
import {
  changeToDecimel,
  formatDate,
  formateDateTime,
  formateDateWithTime,
} from "../../../../utils/commonFunctions";
import { PaperClipIcon } from "../../../Icon";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { ButtonDropdown, DropdownMenu, DropdownToggle } from "reactstrap";
import Avatar from "../../../commons/CircularAvatar/CircularAvatar";


type AppProps = {
  tableHeader: TableHeadersType[];
  handleBomEdit: (id: number) => void;
  currencySign: string | undefined;
  bomListData: [] | BomDataItemType[];
  isEditManufacturingPresent: boolean;
  lockBOMEntriesDate:null|string;
    handleRedirectToEditForm: (data: any) => void;
  

};

const BomListTableData = ({
  tableHeader,
  bomListData,
  currencySign,
  handleBomEdit,
  isEditManufacturingPresent,
  lockBOMEntriesDate,
  handleRedirectToEditForm
}: AppProps) => {
    const [toggle, setToggle] = useState<boolean>(false);
   const [sameIndex, setSameIndex] = useState<any>("-2");
    const handleMoreDataOpen = (data: any, index: any) => {
      setSameIndex(index);
      setToggle(!toggle);
    };

  const renderMoreDetailsInvoiceToolTip = (props: any) => {
    return (
      <Tooltip id="button-view-open-item" {...props}>
        More Details
      </Tooltip>
    );
  };

    const renderLockInvoiceToolTip = (props: any) => {
      return (
        <Tooltip id="button-view-open-item" {...props}>
          Manufacturing Locked
        </Tooltip>
      );
    };
  
    const renderEditInvoiceToolTip = (props: any) => {
      return (
        <Tooltip id="button-view-open-item" {...props}>
           Edit Manufacturing
        </Tooltip>
      );
    };
  let renderData = () => {
    const finalTableData = bomListData?.length
      ? bomListData?.map((dataItem: any, index: number) => {
        let splitedLockedEntries: string | string[] = lockBOMEntriesDate
        ? lockBOMEntriesDate?.split("-")
        : "";
      let splitedInvoiceDate: string[] = formatDate(
        dataItem?.bom_date
      )?.split("-");

      let lockedDate = new Date(
        +splitedLockedEntries[2],
        +splitedLockedEntries[1] - 1,
        +splitedLockedEntries[0]
      );
      let itemDate = new Date(
        +splitedInvoiceDate[2],
        +splitedInvoiceDate[1] - 1,
        +splitedInvoiceDate[0]
      );
          return (
            <tr key={dataItem?.id}>
              {tableHeader?.length &&
                tableHeader?.map((header: TableHeadersType) => {
                  if (header.value === "primary_item") {
                    return (
                      <td style={{ textAlign: "center" }}>
                        {dataItem?.primary_item_name
                          ? dataItem?.primary_item_name
                          : "NA"}
                      </td>
                    );
                  } else if (header.value === "document_no") {
                    return (
                      <td style={{ textAlign: "center" }}>
                        {dataItem?.document_number
                          ? dataItem?.document_number
                          : "NA"}
                      </td>
                    );
                  } else if (header.value === "date") {
                    return (
                      <td style={{ textAlign: "left" }}>
                        {dataItem?.bom_date
                          ? formatDate(dataItem?.bom_date)
                          : "NA"}
                      </td>
                    );
                  } else if (header.value === "attachment") {
                    return !!dataItem?.uploads?.length ? (
                      <td
                        style={{ width: "50px" }}
                        className="position-relative"
                      >
                        <PaperClipIcon />
                        <span className="badge count-badge">
                          {dataItem?.uploads?.length}
                        </span>
                      </td>
                    ) : (
                      <td style={{ width: "50px" }}> --/-- </td>
                    );
                  } 
                  else if (header.value === "approved_by") {
                    return (
                       <td style={{ textAlign: "center" }}>
                                              <div className="d-flex">
                                                {dataItem?.approval_details?.length > 0 ? (
                                                  dataItem?.approval_details?.map(
                                                    (profileData: any) => {
                                                      let fullName =
                                                        profileData?.first_name +
                                                        " " +
                                                        profileData?.last_name;
                      
                                                      return (
                                                        <OverlayTrigger
                                                          placement="top"
                                                          delay={{ show: 250, hide: 250 }}
                                                          overlay={
                                                            <Tooltip id="button-view-open-item">
                                                              {fullName}
                                                              <br></br>
                                                              approved on{" "}
                                                              {formateDateWithTime(
                                                                profileData?.approved_at
                                                              )}
                                                            </Tooltip>
                                                          }
                                                        >
                                                          <span style={{ cursor: "pointer" }}>
                                                            <Avatar
                                                              name={fullName}
                                                              image={
                                                                profileData?.profile_pic?.file_url
                                                              }
                                                            />
                                                          </span>
                                                        </OverlayTrigger>
                                                      );
                                                    }
                                                  )
                                                ) : (
                                                  <span>--/--</span>
                                                )}
                                              </div>
                                            </td>
                    );
                  } 
                  else if (header.value === "effective_cost") {
                    return (
                      <td style={{ textAlign: "left" }}>
                        {dataItem?.effective_cost
                          ? changeToDecimel(dataItem?.effective_cost)
                          : "NA"}
                      </td>
                    );
                  } else if (header.value === "quantity") {
                    return (
                      <td style={{ textAlign: "left" }}>
                        {dataItem?.quantity ? dataItem?.quantity : "NA"}
                      </td>
                    );
                  } else if (header.value === "amount") {
                    return (
                      <td style={{ textAlign: "left" }}>
                        {currencySign}
                        {dataItem?.total_bom_amount
                          ? changeToDecimel(dataItem?.total_bom_amount)
                          : "NA"}
                      </td>
                    );
                  } else if (header.value === "comment") {
                    return (
                      <td style={{ textAlign: "left" }}>
                        {dataItem?.comments ? dataItem?.comments : "NA"}
                      </td>
                    );
                  } else if (header.value === "modified_by") {
                    return (
                      <td style={{ minWidth: "180px" }}>
                        <UpdatedByAndUpdatedAt
                          firstName={dataItem?.updated_by?.first_name}
                          lastName={dataItem?.updated_by?.last_name}
                          profilePic={
                            dataItem?.updated_by?.profile_pic?.file_url
                          }
                          updatedAt={formateDateTime(dataItem?.updated_at)}
                        />
                      </td>
                    );
                  }
                })}
              <td  style={{ width: "72px" }}>
                  {isEditManufacturingPresent &&
                  <>
                                    <OverlayTrigger
                                      placement="top"
                                      delay={{ show: 250, hide: 250 }}
                                      overlay={
                                        lockBOMEntriesDate && itemDate <= lockedDate
                                          ? renderLockInvoiceToolTip
                                          : renderEditInvoiceToolTip
                                      }
                                    >
                                      {lockBOMEntriesDate && itemDate <= lockedDate ? (
                                        <span className="d-inline-block ">
                                          <div
                                            style={{
                                              color: "#d43",
                                              fontSize: 20,
                                              cursor:'not-allowed'
                                            }}
                                          >
                                            <img src={LockGreyIcon} alt="lock" />
                                          </div>
                                        </span>
                                      ) : (
                                        <span
                                          className="d-inline-block pointer"
                                          onClick={() => handleBomEdit(dataItem)}
                                        >
                                          <div
                                            style={{
                                              color: "#d43",
                                              fontSize: 20,
                                            }}
                                          >
                                            <img src={tableEditIcon} alt="edit" />
                                          </div>
                                        </span>
                                      )}
                                    </OverlayTrigger>
                                    </>

                                  }                                                       
                                  {lockBOMEntriesDate && itemDate <= lockedDate ?
                                                                                 <OverlayTrigger
                                                                          placement="top"
                                                                          delay={{ show: 250, hide: 250 }}
                                                                          overlay={renderMoreDetailsInvoiceToolTip}
                                                                        >
                                                                          <span
                                                                            style={{ cursor: "pointer", width: "21px", height: "25px" }}
                                                                            className="ml-2"
                                                                            onClick={() => handleMoreDataOpen(dataItem, index)}
                                                                          >
                                                                            <img
                                                                              style={{ width: "inherit" }}
                                                                              src={TableMoreDetails}
                                                                              alt="more"
                                                                            />
                                                                          </span>
                                                                        </OverlayTrigger>
  :""}
                                                         {+sameIndex === index &&  (
                  <ButtonDropdown
                    isOpen={toggle}
                    toggle={() => {
                      setToggle(!toggle);
                    }}
                  >
                    <DropdownToggle
                      caret
                      color="secondary"
                      style={{
                        background: "none",
                        color: "none",
                        opacity: "1",
                        position: "absolute",
                      }}
                    ></DropdownToggle>
                    <DropdownMenu right direction={"down"}>
                      <div
                        className="pt-1 pr-1 pb-1 pl-4 download-dropdown"
                        style={{ minWidth: "163px", display: "inline-block" }}
                      >
                       
                      
                        {lockBOMEntriesDate && itemDate <= lockedDate ? (
                          <span
                          onClick={() => handleRedirectToEditForm(dataItem)}
                            className="radio-container-vertical"
                          >
                            View Entry
                          </span>
                        ):null}
                      </div>
                    </DropdownMenu>
                  </ButtonDropdown>
                )}
              </td>
            </tr>
          );
        })
      : null;
    return finalTableData;
  };

  return <>{renderData()}</>;
};

export default BomListTableData;
